import { render } from "./MathCalculator.vue?vue&type=template&id=5d9a3ed9"
import script from "./MathCalculator.vue?vue&type=script&lang=js"
export * from "./MathCalculator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__